// extracted by mini-css-extract-plugin
export default {"container":"DdG6KEaS","modal":"ibMJ0l1C","ant-modal-body":"Qetd7u7_"};